<template>
	<div>
		<div class="d-flex align-center ga-2 mb-2">
			<v-btn icon="arrow_back" variant="text" color="primary" @click="emit('back')" />
			<v-icon v-if="campaign.promoLocal" size="small" color="primary">flag</v-icon>
			<div class="flex-grow-1">
				<div class="text-title-medium font-weight-bold text-primary">{{ campaign.label }}</div>
				<div v-if="subtitle" class="text-body-small text-medium-emphasis">{{ subtitle }}</div>
			</div>
		</div>
		<div class="promo-step__actions mb-4">
			<v-btn prepend-icon="info" variant="outlined" color="primary" block @click="detailsOpen = true">{{ t('CampaignDetails') }}</v-btn>
			<v-badge v-if="meansVisible" :content="campaign.applicationDomains.length" color="warning">
				<v-btn prepend-icon="shopping_cart" variant="outlined" color="primary" block @click="meansOpen = true">{{ t('Moyens') }}</v-btn>
			</v-badge>
			<v-btn v-if="campaign.documents.length" prepend-icon="attach_file" variant="outlined" color="primary" block @click="documentsOpen = true">{{ t('Documents') }}</v-btn>
		</div>

		<PromoCampaignBody :campaign="campaign" />

		<DialogControl v-model="detailsOpen" :title="campaign.label" icon="info" max-width="640" :attach="overlayTarget">
			<v-chip v-if="periodChip" color="primary" size="small" class="align-self-start">{{ periodChip }}</v-chip>
			<PromoCampaignTiles :campaign="campaign" />
			<template #actions>
				<v-btn color="primary" variant="tonal" @click="detailsOpen = false">{{ t('Close') }}</v-btn>
			</template>
		</DialogControl>

		<DialogControl v-model="documentsOpen" :title="t('Documents')" :subtitle="campaign.label" icon="attach_file" max-width="520" :attach="overlayTarget">
			<v-list class="pa-0">
				<v-list-item v-for="document in campaign.documents" :key="document.id" :title="document.label" prepend-icon="description" rounded="lg" @click="ops.run({ type: 'openDocument', documentId: document.id })">
					<template #append>
						<v-btn icon="download" variant="text" size="small" @click.stop="ops.run({ type: 'downloadDocument', documentId: document.id })" />
					</template>
				</v-list-item>
			</v-list>
			<template #actions>
				<v-btn color="primary" variant="tonal" @click="documentsOpen = false">{{ t('Close') }}</v-btn>
			</template>
		</DialogControl>

		<PromoMeansDialog v-if="meansVisible" v-model="meansOpen" :campaign="campaign" :editable="meansEditable" />
	</div>
</template>

<script setup>
import { inject, ref, toRef } from 'vue';
import DialogControl from '@/components/controls/DialogControl.vue';
import { usePromoStep } from '@/composables/usePromoStep';
import { usePromoCampaign } from '@/composables/usePromoCampaign';
import PromoCampaignBody from './PromoCampaignBody.vue';
import PromoCampaignTiles from './PromoCampaignTiles.vue';
import PromoMeansDialog from './PromoMeansDialog.vue';

const props = defineProps({
	campaign: { type: Object, required: true },
});
const emit = defineEmits(['back']);

const { ops, t } = usePromoStep();
const overlayTarget = inject('overlayTarget', null);
const { subtitle, periodChip, meansEditable, meansVisible } = usePromoCampaign(toRef(props, 'campaign'));
const detailsOpen = ref(false);
const meansOpen = ref(false);
const documentsOpen = ref(false);
</script>
